import {CommonModule, NgClass} from '@angular/common';
import {NgModule} from '@angular/core';
import {MaterialModule} from "@app/shared/material.module";
import {RouterModule} from "@angular/router";
import {AvatarPipe} from "@app/shared/pipes/avatar.pipe";
import {DisplayBase64ResourcePipe} from "@app/shared/pipes/display-base64-resource.pipe";
import {MatChipSet} from "@angular/material/chips";


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    AvatarPipe,
    DisplayBase64ResourcePipe,
    NgClass
  ],
  exports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    AvatarPipe,
    DisplayBase64ResourcePipe,
    NgClass
  ]
})
export class SharedModule {
}

export declare class MatChipListbox extends MatChipSet {
}
